<template>
  <div class="pdf-book" @click="irParaLivro">
    <div class="card-image">
      <a class="btn-fav" :class="{ active: isFavorited }" @click="toggleFavorite" title="Adicionar aos favoritos">
        <i :class="isFavorited ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
      </a>
      <a class="btn-cart" @click="addToCart" title="Adicionar ao carrinho">
        <i class="fa fa-cart-plus icon"></i>
      </a>
      <img class="img-default" src="../assets/background/capa-padrao-livro.png" />
      <img class="img-hover" src="../assets/background/capa-hover-livro.png" />
      <div class="hover-overlay">
        <p class="price-discipline">R$ {{ displayPrice }}</p>
      </div>
    </div>

    <div class="pdf-info">
      <span class="title-book">{{ book.nome_disciplina }} - Aula {{ book.ordem_aula }}</span>
    </div>
    <div class="hover-purple"></div>
  </div>
</template>

<style scoped src="../styles/CardBook.css" />

<script>
import { getPriceByType, formatPrice } from '@/utils/pricing';

export default {
  name: 'CardBook',
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFavorited: false,
    };
  },
  computed: {
    displayPrice() {
      return formatPrice(getPriceByType('material-didatico'));
    }
  },
  methods: {
    toggleFavorite(event) {
      event.stopPropagation();
      this.isFavorited = !this.isFavorited;
    },
    addToCart(event) {
      event.stopPropagation();
      const item = {
          codigo_disciplina: this.book.codigo_aula,
          nome_disciplina: `${this.book.nome_disciplina} - Aula ${this.book.ordem_aula}`,
          url_imagem: null,
          preco: getPriceByType('material-didatico'),
          tipo: 'material-didatico'
      };
      this.$emit("add-to-cart", item);
    },
    irParaLivro() {
      this.$router.push({
        path: "/book",
        query: {
          amd: this.book.amd_arq_pdf_aula,
          hash: this.book.hash_arq_pdf_aula
        }
      });
    }
  }
};
</script>
